import {
  Member,
  QueryMembersConnection,
} from '../../graphql-generate/graphql-types';

export function getNodesFromConnection(connection: QueryMembersConnection): Member[] {
  return connection.edges.map((item) => item.node);
}
